import leftImage from "./images/sustitutionPhotoLeft.png"
import rigthtImage from "./images/nuevoSustituto.png"
import frontGuide from "./images/frontGuide.webp"
import reserv from "./images/reserva.webp";
import avistaje from "./images/AVISTAJE.webp"
import bioCorredor from "./images/cartelBiocorredor.webp"
import atardecer from "./images/atardecerMisiones.webp"
import lancha from "./images/lanchaPasajeros.webp"
import harvor from "./images/estacionFluvial-1.webp"
import muelles from "./images/muellesDelta.webp"
import sendero from "./images/sendero.webp"
import rowing from "./images/chicaRemando.png"
import lanchaVuelta from "./images/lanchaVuelta.webp"

const cardContent=[
    {
        "name":"Reserva Delta Terra",
        "text":"senderismo por la isla y visita a la reserva natural Delta Terra.",
        "image":leftImage
    },
    {
        "name":"Estancia en la Isla ",
        "text":"almuerzo, senderismo,exploración y deportes en la naturaleza",
        "image":rigthtImage
    }
];
export const miniInfo={
"aves":'Proyecto: “Conozcamos las aves- Visita a una Reserva Natural” Investigaremos sobre las distintas aves que viven en nuestra ecorregión, sus características, hábitos y visitaremos una Reserva Natural.',
"humedales":'Proyecto: Protejamos la Naturaleza- Visita al PN Ciervo de los Pantanos”Aprenderemos sobre: Qué son los humedales?, Porqué es importante conservarlos? Qué especies de flora y fauna viven en el Humedal?Ley de Humedales y más',
"ecologia":'Proyecto: “Separemos en casa nuestros residuos- Armado de compostera”Todos en nuestra casa/colegio generamos residuos. Qué hacemos con ellos?. Separación, reutilización, reciclaje y reducción. Armado de compostera. ',
"mariposas":'Proyecto "Cuidemos las mariposas y su hábitat-armado de jardín para mariposas" Conoceremos las distintas especies de mariposas, sus características, metamorfosis y plantas hospederas.'
}
export const bigInfo={
    "puertoTigre":"saldremos de la estación fluvial de tigre",
    "imgPuertoTigre":harvor,
    "deltaTerra0":'Navegamos hasta el rio Espera y caminamos por un cañaveral alucinante hasta la Reserva Natural Delta Terra.',
    "imgDelta0":lancha,
    "deltaTerra1":'Visitamos su centro de interpretación y nos adentramos por sus senderos para recorrer el centro de la isla.',
    "imgDelta1":sendero,
    "deltaTerra2":'Seguimos el paseo caminando por el camino de sirga del Arroyo Rama Negra hasta llegar a un resto de isla, donde podremos descansar y almorzar.',
    "imgDelta2":rowing,
    "deltaTerra3":'Mas tarde seguiremos nuestro camino disfrutando y conociendo todo el encanto de este ambiente tan particular que son los humedales insulares.',
    "imgDelta3":muelles,
    "return":'Regresamos en lancha hasta Tigre continente.',
    "imgReturn":lancha,
    "bonanza0":'Navegaremos por varios ríos hasta llegar a la Estancia en el rio Carapachay donde nos esperan en la Estancia con un rico asado para almorzar.',
    "imgBonanza0":lancha,
    "bonanza1":'Caminaremos por sus senderos para conocer su flora y fauna.',
    "imgBonanza1":sendero,
    "bonanza2":'Por la tarde tendremos opción de realizar actividades como canoa, cabalgata o tirolesa.',
    "imgBonanza2":rowing,
    "bonanza3":'Es un lugar hermoso y con mucho espacio para conocer y disfrutar de la belleza del delta.',
    "imgBonanza3":muelles,
    "return":'Regresamos en lancha hasta Tigre continente.',
    "imgReturn":lanchaVuelta
}
export const aboutMe={
    "p0":"Mi nombre es Maria Isabel Reguero, tengo 57 años, 2 hijos y soy Lic. en Administración (UBA).Hace 10 años decidí ponerme a estudiar sobre el lugar donde siempre viví, Tigre. Me recibí de Guia de Turismo de Tigre y comencé a estudiar más profundamente sobre la naturaleza. Me recibí de GUARDAPARQUE. (Instituto Perito Moreno. CABA). También intervengo en varias actividades de conservación y restauración del ambiente.",
    "img0":frontGuide,
    "p1":"RESERVA NATURAL RINCON DE MILBERG- TIGRE.Estamos impulsando la creación de esta Reserva urbana en Tigre, para que sirva como lugar de esparcimiento, educación ambiental, conservación de ambientes nativos y restauración de ambientes antropizados. IG reserva_natural_municipaltigre.",
    "img1":reserv,
    "p2":"COA TIGRE DELTA Soy parte de este grupo de observación de aves que pertenece a Aves Argentinas y hacemos relevamientos de aves y salidas de avistajes, abierto a la comunidad. IG coatigredelta",
    "img2":avistaje,
    "p3":"BIOCORREDOR PAUL GROUSSAR. EL TALAR Presente en el 2021, un proyecto a la Municipalidad de Tigre para crear el Biocorredor en la calle Paul Groussac en el Talar. Y lo concretamos en nov. 2021. Fue todo un éxito!!.  IG. biocorredor.paul.groussac",
    "img3":bioCorredor,
    "p4":"VOLUNTARIADO.Estuve voluntariando en nov. 2021, en la Reserva “El Puente Verde” de Aves Argentinas en Comandante Andresito, Misiones. Fue una experiencia fascinante !! ",
    "img4":atardecer

}
export default cardContent;